import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import Announcements from "@/pages/Announcements";
import Login from "@/pages/Login";
import Me from "@/pages/Me";
import PortalHome from "@/pages/PortalHome";
import CommandCenter from "@/pages/CommandCenter";
import AdminCenter from "@/pages/AdminCenter";
import RoutingRules from "@/pages/RoutingRules";
import Problems from "@/pages/Problems";
import Contracts from "@/pages/Contracts";
import RenewalPack from "@/pages/RenewalPack";
import Catalog from "@/pages/Catalog";
import Queue from "@/pages/Queue";
import Rebid from "@/pages/Rebid";
import OperationsCalendar from "@/pages/OperationsCalendar";
import KnowledgePortal from "@/pages/KnowledgePortal";
import Assets from "@/pages/Assets";
import Outages from "@/pages/Outages";
import Changes from "@/pages/Changes";
import CIExplorer from "@/pages/CIExplorer";
import Projects from "@/pages/Projects";
import Surveys from "@/pages/Surveys";
import Approvals from "@/pages/Approvals";
import CapacityPlanner from "@/pages/CapacityPlanner";
import Releases from "@/pages/Releases";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={
            <AppShell>
              <Routes>
                <Route path="/" element={<PortalHome />} />
                <Route path="/me" element={<Me />} />
                <Route path="/command-center" element={<CommandCenter />} />
                <Route path="/admin" element={<AdminCenter />} />
                <Route path="/admin/routing" element={<RoutingRules />} />
                <Route path="/admin/announcements" element={<Announcements />} />
                <Route path="/problems" element={<Problems />} />
                <Route path="/contracts" element={<Contracts />} />
                <Route path="/contracts/renewal-pack/:vendorKey" element={<RenewalPack />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/queue" element={<Queue />} />
                <Route path="/rebid" element={<Rebid />} />
                <Route path="/calendar" element={<OperationsCalendar />} />
                <Route path="/knowledge" element={<KnowledgePortal />} />
                <Route path="/assets" element={<Assets />} />
                <Route path="/outages" element={<Outages />} />
                <Route path="/changes" element={<Changes />} />
                <Route path="/cmdb" element={<CIExplorer />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/surveys" element={<Surveys />} />
                <Route path="/approvals" element={<Approvals />} />
                <Route path="/capacity" element={<CapacityPlanner />} />
                <Route path="/releases" element={<Releases />} />
              </Routes>
            </AppShell>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
